import React from 'react';
import _CopyRight from './_CopyRight.scss'

class CopyRight extends React.Component {

  render() {
    return (
      <div className='copyright-container'>
        <p className='footer-description'>Đơn vị chủ quản: SỞ CÔNG THƯƠNG TỈNH QUẢNG NGÃI</p>
        <p className='footer-description'>Địa chỉ: 58 Phạm Văn Đồng - Thành phố Quảng Ngãi - Tỉnh Quảng Ngãi</p>
        <p className='footer-description'>ĐT: 0255 382 0254. Email: <a href="mailto:(quangngaitrade.gov@gmail.com)">quangngaitrade.gov@gmail.com</a></p>
        <div className='external-links'>
          <a href='https://tinnhiemmang.vn/danh-ba-tin-nhiem/quangngaitradegovvn-1688611891' target="_blank"><img className='img-footer' src='https://tinnhiemmang.vn/storage/photos/shares/CetificateTrust/web_basic_2x.png' alt=''/></a> 
          <a href="https://ipv6-test.com/validate.php?url=referer" target="_blank"><img src="https://ipv6-test.com/button-ipv6-big.png" alt="ipv6 ready" title="ipv6 ready" style={{borderWidth: 0, borderStyle: 'solid',display: "unset"}}/> </a>
        </div>
      </div>
    );
  }
}
export default CopyRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/CopyRight.jsx